'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = function (WrappedComponent) {
  return function (props) {
    var data = _lodash2.default.get(props.data, 'data', props.data); // http://jsonapi.org/format/#document-structure


    var children = props.children,
        config = props.config,
        configSubpath = props.configSubpath,
        eventHandlers = props.eventHandlers;

    var wrappedRenderTree = function wrappedRenderTree(tree) {
      return (0, _render.renderTree)(tree, {
        children: children,
        config: config,
        configSubpath: configSubpath,
        data: data,
        eventHandlers: eventHandlers
      });
    };

    return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, props, {
      renderTree: wrappedRenderTree
    }));
  };
};

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _render = require('../../utils/render');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}